import type { WeeklyAdminState } from '../api.js';
type Config = WeeklyAdminState['template'];
export function validateCompetitionDraft(config: Config): string[] {
  const issues: string[] = [];
  if (config.enabled && config.rankRewards.length === 0) issues.push('开启有奖比赛前，请至少添加一档名次奖励。');
  config.rankRewards.forEach((range, index) => {
    const name = `第 ${index + 1} 档（第 ${range.fromRank}–${range.toRank} 名）`;
    if (!range.reward.items.length) issues.push(`${name}还没有发放内容，请点击“增加一项奖励”，或删除这档空配置。`);
    if (!Number.isInteger(range.fromRank) || !Number.isInteger(range.toRank) || range.fromRank < 1 || range.toRank < range.fromRank || range.toRank > 1000000) issues.push(`${name}的名次范围不合法，结束名次不能小于开始名次。`);
    const types = new Set<string>();
    for (const item of range.reward.items) {
      const key = item.type === 'tool_entitlement' ? `${item.type}:${item.toolId}` : item.type;
      if (types.has(key)) issues.push(`${name}有重复奖励，请合并为一项。`);
      types.add(key);
      const count = item.type === 'tool_entitlement' ? item.count : item.amount;
      const max = item.type === 'tool_entitlement' ? 99 : 1000000;
      if (!Number.isInteger(count) || count < 1 || count > max) issues.push(`${name}的奖励数量必须为 1–${max} 的整数。`);
      if (item.type === 'stamina') issues.push(`${name}只支持鱼干币和道具奖励。`);
    }
  });
  const sorted = config.rankRewards.map((range,index)=>({...range,index})).sort((a,b)=>a.fromRank-b.fromRank);
  for(let i=1;i<sorted.length;i++)if(sorted[i]!.fromRank<=sorted[i-1]!.toRank)issues.push(`第 ${sorted[i-1]!.index+1} 档和第 ${sorted[i]!.index+1} 档的名次重叠，请调整范围。`);
  for(const [key,name] of [['normal','普通关'],['hard','困难关'],['superHard','超难关']] as const)if(!Number.isInteger(config.points[key])||config.points[key]<1||config.points[key]>1000000)issues.push(`${name}积分必须为 1–1000000 的整数。`);
  return [...new Set(issues)];
}
